import { useState } from 'react';
import { FiKey, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../services/api';

const MySecurity = () => {
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const toggleShow = (field) =>
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      toast.error('Mật khẩu mới và xác nhận mật khẩu không khớp');
      return;
    }

    try {
      setSaving(true);
      await api.post('/auth/security/change-password', {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });

      setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      toast.success('Đổi mật khẩu thành công');
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || 'Không thể đổi mật khẩu');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">Đổi mật khẩu</h2>
        <p className="text-sm text-slate-500">Cập nhật mật khẩu để bảo vệ tài khoản.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Mật khẩu hiện tại</label>
          <div className="flex items-center rounded-md border border-slate-300 bg-white px-3 py-2">
            <FiLock className="mr-2 text-slate-400" />
            <input
              type={showPassword.currentPassword ? 'text' : 'password'}
              className="w-full border-none bg-transparent text-sm text-slate-800 outline-none"
              value={formData.currentPassword}
              onChange={(event) => setFormData((prev) => ({ ...prev, currentPassword: event.target.value }))}
              required
            />
            <button
              type="button"
              onClick={() => toggleShow('currentPassword')}
              className="ml-2 text-slate-400 hover:text-slate-600 focus:outline-none"
              tabIndex={-1}
            >
              {showPassword.currentPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
            </button>
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Mật khẩu mới</label>
          <div className="flex items-center rounded-md border border-slate-300 bg-white px-3 py-2">
            <FiKey className="mr-2 text-slate-400" />
            <input
              type={showPassword.newPassword ? 'text' : 'password'}
              className="w-full border-none bg-transparent text-sm text-slate-800 outline-none"
              value={formData.newPassword}
              onChange={(event) => setFormData((prev) => ({ ...prev, newPassword: event.target.value }))}
              minLength={6}
              required
            />
            <button
              type="button"
              onClick={() => toggleShow('newPassword')}
              className="ml-2 text-slate-400 hover:text-slate-600 focus:outline-none"
              tabIndex={-1}
            >
              {showPassword.newPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
            </button>
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Xác nhận mật khẩu mới</label>
          <div className="flex items-center rounded-md border border-slate-300 bg-white px-3 py-2">
            <FiKey className="mr-2 text-slate-400" />
            <input
              type={showPassword.confirmPassword ? 'text' : 'password'}
              className="w-full border-none bg-transparent text-sm text-slate-800 outline-none"
              value={formData.confirmPassword}
              onChange={(event) => setFormData((prev) => ({ ...prev, confirmPassword: event.target.value }))}
              minLength={6}
              required
            />
            <button
              type="button"
              onClick={() => toggleShow('confirmPassword')}
              className="ml-2 text-slate-400 hover:text-slate-600 focus:outline-none"
              tabIndex={-1}
            >
              {showPassword.confirmPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
            </button>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-dark disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FiKey />
            {saving ? 'Đang cập nhật...' : 'Cập nhật mật khẩu'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default MySecurity;